import React from 'react'
import './movimentations-progress.css'

const MovimentationsProgress = props => {
    const data = props.data
    return (
        <div className="movimentations-progress-container">
            <div style={{ display: 'flex', justifyContent: 'space-around' }}>
                {data.map((d, i) => {
                    return (
                        <div style={{ display: 'flex' }} key={i}>
                            <div className="movimentation-progress-radio" style={{ backgroundColor: d.color }} />
                            <span className="txt-color movimentation-progress-title">{d.label}</span>
                        </div>
                    )
                })}
            </div>

            <div style={{ display: 'flex', flexDirection: 'column' }}>

                {data.map((d, i) => {
                    return (
                        <div style={{ display: 'flex', alignItems: 'center'}} key={i}>

                            <div style={{ width: '20%', maxWidth: '52px' }}>
                                <span className="txt-color movimentation-progress-title" style={{ fontWeight: 'bold' }}>{d.value}</span>
                            </div>
                            <div style={{width: '90%'}}>

                            <div className="movimentation-progress-bar" style={{ backgroundColor: d.color, width: `${d.percent}%` }} />
                            </div>
                        </div>
                    )
                })}
            </div>



        </div>
    )
}

export default MovimentationsProgress